// extracted by mini-css-extract-plugin
export default {"label":"zJU2oB"};